import {
  ActionList,
  ActionListItem,
  Divider,
  GridItem,
  Link,
  PrimaryTag,
  Text,
} from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import React from "react";
import { Trans } from "react-i18next";

import { AddressModal } from "./AddressModal";
import { getAddressDate, getErrorMessage } from "./utils";

type AddressesListProps = {
  addresses: components["schemas"]["AddressesCheckFieldValue"][];
  onSave: (
    address: components["schemas"]["AddressesCheckFieldValue"],
    index: number
  ) => void;
  onDelete: (index: number) => void;
};

export function AddressesList({
  addresses,
  onSave,
  onDelete,
}: AddressesListProps) {
  const currentAddressIndex = addresses.findIndex(({ end_date }) => !end_date);

  const sortedAddresses = addresses
    .map((address, i) => ({ ...address, index: i }))
    .sort(({ end_date }) => (end_date ? 1 : -1));

  return (
    <GridItem>
      <ActionList>
        {sortedAddresses.map((address) => (
          <React.Fragment key={address.index}>
            <ActionListItem
              testID="address-history-list"
              title={address.address}
              tag={
                !address.end_date && (
                  <PrimaryTag type="subtle">
                    <Trans>Current</Trans>
                  </PrimaryTag>
                )
              }
              errorMessage={getErrorMessage(address, addresses)}
              trailing={
                <AddressModal
                  index={address.index}
                  address={address}
                  onSave={onSave}
                  onDelete={() => onDelete(address.index)}
                  allowCurrent={
                    currentAddressIndex === -1 ||
                    currentAddressIndex === address.index
                  }
                  trigger={
                    <Link
                      linkStyle="monochrome"
                      textStyle="global/body-secondary"
                      testID={`address-history-${
                        address.index + 1
                      }-edit-history-button`}
                    >
                      <Trans>Edit</Trans>
                    </Link>
                  }
                />
              }
            >
              <Text style="global/body-secondary" color="text-weak">
                {!!address.end_date &&
                  `${address.city}, ${address.province_state} ${address.country}`}
              </Text>
              <Text style="global/body-secondary" color="text-weak">
                {getAddressDate(address)}
              </Text>
            </ActionListItem>
            <Divider />
          </React.Fragment>
        ))}
      </ActionList>
    </GridItem>
  );
}
